import React from 'react';
import styled from 'styled-components';

const IncomeModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 26rem;
    img {
        height: 7.8rem;
        width: 7.8rem;
        align-self: center;
        margin-bottom: 0.8rem;
    }
    h1 {
        margin-left: 1.1rem;
        margin-top: 0.5rem;
        margin-bottom: 1rem;
    }
    p {
        font-size: 1.6rem;
        color: var(--color-footergray);
        margin-right: 1.3rem;
        margin-left: 1.3rem;
        margin-bottom: 2.5rem;
    }
    Button {
        margin-top: auto;
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
`;

const IncomeMaxRetry = ({ onClick, url }) => {
    return (
        <IncomeModalWrapper>
            <h1>Income Verification</h1>
            <p>{url}</p>
        </IncomeModalWrapper>
    );
};

export default IncomeMaxRetry;
